import React from "react";
import {SelectRangeModalWrapper} from "components/molecules/SelectRangeModal/SelectRangeModal.style";
import CalenderIcon from "assets/calander.svg";
import {format} from "date-fns";
import Button from "components/molecules/Button";
import ReactDateRange from "components/atoms/DatePicker";
import CloseIcon from "../../../assets/close-icon.svg";

const SelectRangeModal = ({startDate, endDate, onChange, onApplyDate, onClearDate, onClose}) => {
    const applyDate = () => {
        onApplyDate();
        onClose();
    };
    return (
        <SelectRangeModalWrapper>
            <div className="selectRangeWrap">
                {" "}
                <div className="filter-div">
                    {/* <h2>Filter</h2> */}
                    {/* <div className="close-icon" onClick={onClose}>
          <img src={CloseIcon} alt="close_icon" />
        </div> */}
                    <div className="inner-container">
                        <img src={CalenderIcon} alt="Calender" />
                        <div className="desc">
                            <h6>Start Date</h6>
                            <span>{startDate ? format(startDate, "yyyy-MM-dd") : "YYYY/DD/MM"}</span>
                        </div>
                    </div>
                    <div className="inner-container">
                        <img src={CalenderIcon} alt="Calender" />
                        <div className="desc">
                            <h6>End Date</h6>
                            <span>{endDate ? format(endDate, "yyyy-MM-dd") : "YYYY/DD/MM"}</span>
                        </div>
                    </div>
                </div>
                <div className="date-picker">
                    <ReactDateRange
                        selected={startDate}
                        onChange={onChange}
                        startDate={startDate}
                        endDate={endDate}
                        selectsRange
                        selectsDisabledDaysInRange
                        inline
                    />
                </div>
            </div>
            <div className="btn-wrapper">
                <Button onClick={applyDate} width="87">
                    Apply
                </Button>
                <Button onClick={onClearDate} disabled={!startDate && !endDate} width="87">
                    Reset
                </Button>
            </div>
        </SelectRangeModalWrapper>
    );
};

export default SelectRangeModal;
